import { MULTI_PARTIAL_PER_SHIFT, ongoingRequestStatuses, ongoingProposalStatuses } from '../../../constants';

/**
 * 
 * @param {import('../../../../services/Slider/PartialSliderHelper').StoreData} storeData 
 * @param {number} shiftId 
 * @param {boolean?} isFullValidation 
 * @returns {{ isNewRequestBlocked: false, blockingManagerAggregateRootIds: string[], multiplePartialCount: number}}
 */
export const getSettingsOfExistingOffersBlockingNewRequest = (storeData, shiftId, isFullValidation = true) => {
    let result = {
        isNewRequestBlocked: false,
        blockingManagerAggregateRootIds: [],
        multiplePartialCount: 0,
    }

    const activeToCoverOffersWithSameShiftId = storeData.employeeShiftOffers.filter(ele =>
        ele.shift.id === shiftId
        && ongoingRequestStatuses.includes(ele.status)
    ) || [];
    const activeShiftSwapOffersWithSameShiftId = storeData.employeeMyShiftSwapOffers.filter(offer =>
        offer.shifts.find(shift => shift.id === shiftId)
        && ongoingRequestStatuses.includes(offer.status)
    );

    const activeProposalsWithSameShiftId = storeData.myProposals.reduce((prev, curr) => {
        const proposal = curr.proposals.find(p =>
            p.shifts.find(shift => shift.id === shiftId)
            && ongoingProposalStatuses.includes(p.status));
        if (proposal){
            return [
                ...prev,
                {
                    isPartial: proposal.isPartial,
                    isMultiplePartial: proposal.isMultiplePartial,
                    managerSettingAggregateRootId: curr.managerSettingAggregateRootId
                }];
        }
        return prev;
    }, []);

    const activeOffersAndProposals = [...activeToCoverOffersWithSameShiftId, ...activeShiftSwapOffersWithSameShiftId, ...activeProposalsWithSameShiftId].map(x => ({
        managerSettingAggregateRootId: x.managerSettingAggregateRootId,
        isPartial: x.isPartial,
        isMultiplePartial: x.isMultiplePartial,
    }));

    if (!isFullValidation) {// just check if list has any offers with same shift id
        result.isNewRequestBlocked = !!activeOffersAndProposals.length;
        result.blockingManagerAggregateRootIds = activeOffersAndProposals.map(x => x.managerSettingAggregateRootId);
        return result;
    }
    
    for (let offer of activeOffersAndProposals) {
        if (!offer.isPartial) {
            result.isNewRequestBlocked = true;
            result.blockingManagerAggregateRootIds = [offer.managerSettingAggregateRootId]
            return result; // There exists an offer with this shift that does not allow partials
        }
        else {
            if (!offer.isMultiplePartial) {
                result.isNewRequestBlocked = true;
                result.blockingManagerAggregateRootIds = [offer.managerSettingAggregateRootId];
                return result; // There exists an offer with this shift that allows partials but does not allow multiple partials
            }
            else {
                if (++result.multiplePartialCount >= MULTI_PARTIAL_PER_SHIFT) {
                    return result; // There exists an offer with this shift that allows multipartials but there are already 2
                }
            }
        }
    }
    return result;
}
